import { useEffect } from 'react';

const AngelAIWidget = ({ customLink, userType, isReady = true }) => {

  // One-time legacy cleanup
  useEffect(() => {
    document.getElementById('mini-Morgan-chat-widget')?.remove();
    ['angelai-widget-lo', 'angelai-widget-influencer'].forEach(id => {
      document.getElementById(id)?.remove();
    });
    ['angelai-widget-styles-lo', 'angelai-widget-styles-influencer'].forEach(id => {
      document.getElementById(id)?.remove();
    });
  }, []);

  // Load widget once when ready, update attributes on subsequent changes
  useEffect(() => {
    if (!isReady) return;

    const existingScript = document.getElementById('angelai-widget');
    if (existingScript) {
      existingScript.setAttribute('userType', userType || 'default');
      if (customLink) {
        const normalized = customLink.endsWith('/') ? customLink : customLink + '/';
        existingScript.setAttribute('angelaiCustomLink', normalized);
      } else {
        existingScript.removeAttribute('angelaiCustomLink');
      }
      return;
    }

    let normalizedLink = customLink;
    if (customLink && !customLink.endsWith('/')) {
      normalizedLink = customLink + '/';
    }

    // No cleanup/cancel — the DOM check inside prevents duplicates.
    // Cancelling on cleanup causes StrictMode + batched state updates to
    // repeatedly kill the timer before it fires.
    setTimeout(() => {
      if (document.getElementById('angelai-widget')) return;

      const cssLink = document.createElement('link');
      cssLink.id = 'angelai-widget-styles';
      cssLink.rel = 'stylesheet';
      cssLink.href = `${process.env.REACT_APP_ANGELAI_WIDGET_CSS}?v=${Date.now()}`;
      document.head.appendChild(cssLink);

      const script = document.createElement('script');
      script.id = 'angelai-widget';
      script.src = `${process.env.REACT_APP_ANGELAI_WIDGET_JS}?v=${Date.now()}`;
      script.setAttribute('comicBubbleBackground', '#ffffffe6');
      script.setAttribute('comicBubbleBorderColor', '#FF6A1360');
      script.setAttribute('userType', userType || 'default');
      if (normalizedLink) {
        script.setAttribute('angelaiCustomLink', normalizedLink);
      }
      document.body.appendChild(script);
    }, 300);
  }, [customLink, userType, isReady]);

  return null;
};

export default AngelAIWidget;
